import React, { useEffect } from "react";
import Textfield from "../../InviteUserModal/Textfield";
import "./style.css";
import ErrorText from "../../commonComponents/ErrorTextContainer";
import { WEBSITE_REGEX } from "../../../utils/utils";
import { updateService } from "../../../utils/services";
function Close({ onClick }: { onClick: () => void }) {
  return (
    <button
      className="block cursor-pointer relative shrink-0 size-6"
      data-name="Close"
      onClick={onClick}
    >
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
      >
        <g id="Close">
          <path
            d="M18 6L6 18M6 6L18 18"
            id="Icon"
            stroke="var(--stroke-0, #211F26)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </svg>
    </button>
  );
}

function HDivider() {
  return (
    <div className="h-0 relative shrink-0 w-full" data-name="H Divider">
      <div
        className="absolute bottom-full left-0 right-0 top-0"
        data-name="H Divider"
      >
        <div className="absolute bottom-[-0.5px] left-[-0.125%] right-[-0.125%] top-[-0.5px]">
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 402 2"
          >
            <path
              d="M1 1H401"
              id="H Divider"
              stroke="var(--stroke-0, #EAE7EC)"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
export default function EditService({
  onClose,
  serviceDetails,
  fetchServices,
}) {
  console.log("serviceDetails", serviceDetails);
  const [nameError, setNameError] = React.useState("");
  const [descriptionError, setDescriptionError] = React.useState("");
  const [groupNameError, setGroupNameError] = React.useState("");
  const [displayNameError, setDisplayNameError] = React.useState("");
  const [displayName, setDisplayName] = React.useState(
    serviceDetails.displayName || "",
  );
  const [description, setDescription] = React.useState(
    serviceDetails.desc || "",
  );
  const [pageUrl, setPageUrl] = React.useState(serviceDetails.pageUrl || "");
  const [setPageUrlError, setSetPageUrlError] = React.useState("");
  const [imageUrl, setImageUrl] = React.useState(serviceDetails.imageUrl || "");
  const [imageUrlError, setImageUrlError] = React.useState("");

  useEffect(() => {
    setPageUrl(serviceDetails.pageUrl || "");
    setDisplayName(serviceDetails.displayName || "");
    setDescription(serviceDetails.desc || "");
    setImageUrl(serviceDetails.imgUrl || "");
  }, [serviceDetails]);

  const handleUpdateService = () => {
    console.log("@handleUpdateService");

    if (!pageUrl || pageUrl.trim() === "") {
      setSetPageUrlError("Page Url is required");
      return;
    } else {
      setSetPageUrlError("");
    }

    if (WEBSITE_REGEX.test(pageUrl) === false) {
      setSetPageUrlError("Enter valid Page Url");
      return;
    } else {
      setSetPageUrlError("");
    }

    if (!imageUrl || imageUrl.trim() === "") {
      setImageUrlError("Image Url is required");
      return;
    } else {
      setImageUrlError("");
    }

    //api call to update service

    updateService(serviceDetails._id, {
      pageUrl,
      displayName,
      desc: description,
      imgUrl: imageUrl,
    })
      .then((res) => {
        console.log("Service updated successfully", res);
        fetchServices();
        onClose();
      })
      .catch((err) => {
        console.log("Error updating service", err);
      });
  };

  return (
    <div
      className="backdrop-blur-[20px] backdrop-filter bg-[rgba(255,255,255,0.72)] box-border content-stretch flex flex-col gap-2 h-[100vh] items-start justify-start p-[56px] relative rounded-tl-[24px] rounded-bl-[24px] shadow-[-4px_0px_24px_0px_rgba(0,0,0,0.02)] shrink-0"
      data-name="Create Workspace Modal"
    >
      <div className="box-border content-stretch flex flex-col gap-8 items-start justify-start p-0 relative shrink-0 w-[400px] h-full">
        <div className="box-border content-stretch flex flex-row gap-6 items-center justify-center p-0 relative shrink-0 w-full">
          <div className="basis-0 font-['Geist:Medium',_sans-serif] font-medium grow leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[24px] text-left tracking-[-0.24px]">
            <p className="block leading-[30px]">Edit Service</p>
          </div>
          <Close onClick={onClose} />
        </div>{" "}
        <HDivider />
        <div className="customer-info-input">
          <div className="input-tab-service">
            <Textfield
              label="Service Name"
              value={serviceDetails.name}
              onChange={() => {}}
              placeholder="Enter Service Name"
              type="text"
            />
            {nameError && <ErrorText hasError={nameError}></ErrorText>}
          </div>
          <div className="input-tab-service">
            <Textfield
              label="Service Display name"
              value={displayName}
              onChange={(value) => setDisplayName(value)}
              placeholder="Enter Service Display Name"
              type="text"
            />
            {displayNameError && (
              <ErrorText hasError={displayNameError}></ErrorText>
            )}
          </div>
          <div className="input-tab-service">
            <Textfield
              label="Service Group Name"
              value={serviceDetails.groupName}
              onChange={() => {}}
              placeholder="Enter Service Group Name"
              type="text"
            />
            {groupNameError && (
              <ErrorText hasError={groupNameError}></ErrorText>
            )}
          </div>
          <div className="input-tab-service">
            <Textfield
              label="Service Description"
              value={description}
              onChange={(value) => setDescription(value)}
              placeholder="Enter Service Description"
              type="text"
            />
            {descriptionError && (
              <ErrorText hasError={descriptionError}></ErrorText>
            )}
          </div>

          <div className="input-tab-service">
            <Textfield
              label="Page Url"
              value={pageUrl}
              onChange={(value) => {
                console.log("value", value);
                setPageUrl(value);
              }}
              placeholder="Enter Page Url"
              type="text"
            />
            {setPageUrlError && (
              <ErrorText hasError={setPageUrlError}></ErrorText>
            )}
          </div>

          <div className="input-tab-service">
            <Textfield
              label="Image Url"
              value={imageUrl}
              onChange={(value) => {
                console.log("value", value);
                setImageUrl(value);
              }}
              placeholder="Enter Image Url"
              type="text"
            />
            {imageUrlError && <ErrorText hasError={imageUrlError}></ErrorText>}
          </div>
        </div>
        <button onClick={handleUpdateService} className="update-service">
          Update Detiails
        </button>
      </div>
    </div>
  );
}
